import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const AdsFilter = () => {
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const status = [
    { value: "active", label: "نشطة" },
    { value: "inactive", label: "غير نشطة" },
  ];
  const roles = [
    { value: "user", label: "العملاء" },
    { value: "contractor", label: "المقاولون" },
    { value: "supplier", label: "الموردون" },
  ];
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const statusParam = params.get("status");
    const roleParam = params.get("targetRole");
    if (statusParam) {
      setSelectedStatus(statusParam);
    } else {
      setSelectedStatus("");
    }
    if (roleParam) {
      setSelectedRole(roleParam);
    } else {
      setSelectedRole("");
    }
  }, [location.search]);

  const handleFilter = (name, value) => {
    const params = new URLSearchParams(location.search);

    if (value === "") {
      params.delete(name);
    } else {
      params.set(name, value);
    }

    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };
  return (
    <div className="flex gap-2">
      <select
        className="rounded-md bg-blueSecondary py-1 px-3 text-white"
        onChange={(event) => handleFilter("status", event.target.value)}
        value={selectedStatus}
        name="status"
      >
        <option value="">كل الحالات</option>
        {status.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
      <select
        className="rounded-md bg-blueSecondary py-1 px-3 text-white"
        onChange={(event) => handleFilter("targetRole", event.target.value)}
        value={selectedRole}
        name="targetRole"
      >
        <option value="">كل الأدوار</option>
        {roles.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default AdsFilter;
